exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".settings-reset-password a[target=_blank]{font-size:18px;color:#ff5007;text-decoration:none;border-bottom:1px}.settings-reset-password a[target=_blank]:hover{opacity:.7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/containers/Settings/Settings.scss
// module id = 757
// module chunks = 5